import authorityIndex from '@/views/authority/index';
import CommonMain from '@/views/commonMain';


export default {
  path: '/authority',
  component: CommonMain,
  redirect: '/authority',
  children: [
    {
      name: '权限管理',
      meta: { title: '权限管理' },
      path: '',
      component: authorityIndex,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/authority.js